<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-overlay :show="isLoading">
        <b-form @submit="onSubmit">
          <b-form-group :label="$t('tuevs.examresult.form.fields.codigo.label')" label-for="input-codigo">
            <b-form-input id="input-codigo" v-model="examresult.code" type="text"/>
          </b-form-group>
          <b-form-group :label="$t('tuevs.examresult.form.fields.nome.label')" label-for="input-name">
            <b-form-input id="input-name" v-model="examresult.name" type="text"/>
          </b-form-group>

          <b-form-group
              :label="$t('tuevs.examresult.form.fields.status.label')"
              label-for="input-status"
              :description="$t('tuevs.examresult.form.fields.status.description')"
          >
            <b-form-checkbox id="input-status" v-model="examresult.status" size="lg" switch/>
          </b-form-group>
          <b-button type="submit" variant="success">
            <i class="fas fa-save"/> {{ $t('tuevs.examresult.form.fields.botao_salvar') }}
          </b-button>
        </b-form>
      </b-overlay>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import ExamResultRepository from '@/repositories/tuevs/ExamResultRepository'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient
  },
  computed: {
    ...mapGetters({
      examresult: 'tuevs/examresult/current',
      isLoading: 'tuevs/examresult/isLoading'
    }),
    pageTitle() {
      if (this.$route.params.id) return this.$t('tuevs.examresult.form.titulo_pagina.editar')
      return this.$t('tuevs.examresult.form.titulo_pagina.criar')
    }
  },
  methods: {
    ...mapActions([
      'tuevs/examresult/listOne'
    ]),
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      ExamResultRepository.post(this.examresult).then(() => {
        this.$snotify.success(this.$t('tuevs.examresult.form.create.success'))
        this.$router.push({name: 'tuevs.examresult'})
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.examresult.form.create.error'))
        if (error.response.status === 422) {
          ExamResultRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      ExamResultRepository.put(this.$route.params.id, this.examresult).then(() => {
        this.$snotify.success(this.$t('tuevs.examresult.form.update.success'))
        this.$router.push({name: 'tuevs.examresult'})
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.examresult.form.update.error'))
        if (error.response.status === 422) {
          ExamResultRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    this.$store.commit('tuevs/examresult/setCurrent', {status: false})
    if (this.$route.params.id) {
      await this['tuevs/examresult/listOne'](this.$route.params.id)
      this.$store.commit('tuevs/examresult/setCurrent', {...this.examresult, status: !!this.examresult.status})
    }
  }
}
</script>
